// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1T7zt","cell":"ColumnAccessor_cell__2QFul","firstCellAccent":"ColumnAccessor_firstCellAccent__3_1D-"};